import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getMe } from '../../../../../crud/profile.crud';
import { actions as authActions } from '../../../../../store/ducks/auth.duck';
import {IServerResponse} from "../../../../../interfaces/server";
import {IUser} from "../../../../auth/interfaces";

export const useGetMe = () => {
  const dispatch = useDispatch();

  const fetchMe = useCallback(async () => {
    return new Promise<IUser>((resolve) => {
      getMe()
        .then((res: {data: IServerResponse<IUser>}) => {
          dispatch(authActions.loginSetUser(res.data.data));
          resolve(res.data.data);
        })
        .catch((err) => {
          console.error('Error fetching user data:', err);
        })
        .finally(() => {
          console.log('FetchMe execution finished');
        });
    });

  }, []);

  return { fetchMe };
};
